/* ============================================================
   TOL DROP — scroll reveals
   IntersectionObserver, no libraries. Transform/opacity only.
   Targets are tagged here (not in Dawn's snippets) so the theme
   stays upgrade-safe. If anything fails, content stays visible.
   ============================================================ */
(function () {
  'use strict';

  var doc = document.documentElement;
  doc.classList.add('js');

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var targets = [];

  function tag(selector, staggerMs) {
    var els = document.querySelectorAll(selector);
    for (var i = 0; i < els.length; i++) {
      els[i].classList.add('tol-reveal');
      if (staggerMs) {
        els[i].style.setProperty('--tol-reveal-delay', i * staggerMs + 'ms');
      }
      targets.push(els[i]);
    }
  }

  // Section headings and product cards (Dawn's own markup, untouched)
  tag('.collection .collection__title', 0);
  tag('.collection .card-wrapper', 90);
  // The ticker itself gets a quiet entrance too
  tag('.tol-ticker', 0);

  // Reduced motion or no observer: show everything, animate nothing
  if (reduceMotion || !('IntersectionObserver' in window)) {
    for (var j = 0; j < targets.length; j++) {
      targets[j].classList.add('is-in');
    }
    return;
  }

  var io = new IntersectionObserver(
    function (entries) {
      for (var k = 0; k < entries.length; k++) {
        if (entries[k].isIntersecting) {
          entries[k].target.classList.add('is-in');
          io.unobserve(entries[k].target);
        }
      }
    },
    { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
  );

  for (var m = 0; m < targets.length; m++) {
    io.observe(targets[m]);
  }
})();
